// extracted by mini-css-extract-plugin
export default {"root":"UserInfoForm_root__lkDct","card":"UserInfoForm_card__KSuu2","infoCard":"UserInfoForm_infoCard__eRmnO","label":"UserInfoForm_label__aGSV0"};